import type { SVGProps } from 'react'

const SvgViewBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 8.8C8.90909 8.8 9.68182 8.47917 10.3182 7.8375C10.9545 7.19583 11.2727 6.41667 11.2727 5.5C11.2727 4.58333 10.9545 3.80417 10.3182 3.1625C9.68182 2.52083 8.90909 2.2 8 2.2C7.09091 2.2 6.31818 2.52083 5.68182 3.1625C5.04545 3.80417 4.72727 4.58333 4.72727 5.5C4.72727 6.41667 5.04545 7.19583 5.68182 7.8375C6.31818 8.47917 7.09091 8.8 8 8.8ZM8 7.48C7.45455 7.48 6.99091 7.2875 6.60909 6.9025C6.22727 6.5175 6.03636 6.05 6.03636 5.5C6.03636 4.95 6.22727 4.4825 6.60909 4.0975C6.99091 3.7125 7.45455 3.52 8 3.52C8.54545 3.52 9.00909 3.7125 9.39091 4.0975C9.77273 4.4825 9.96364 4.95 9.96364 5.5C9.96364 6.05 9.77273 6.5175 9.39091 6.9025C9.00909 7.2875 8.54545 7.48 8 7.48ZM8 11C6.2303 11 4.61818 10.5019 3.16364 9.50583C1.70909 8.50972 0.654545 7.17444 0 5.5C0.654545 3.82556 1.70909 2.49028 3.16364 1.49417C4.61818 0.498056 6.2303 0 8 0C9.7697 0 11.3818 0.498056 12.8364 1.49417C14.2909 2.49028 15.3455 3.82556 16 5.5C15.3455 7.17444 14.2909 8.50972 12.8364 9.50583C11.3818 10.5019 9.7697 11 8 11ZM8 9.53333C9.3697 9.53333 10.6273 9.16972 11.7727 8.4425C12.9182 7.71528 13.7939 6.73444 14.4 5.5C13.7939 4.26556 12.9182 3.28472 11.7727 2.5575C10.6273 1.83028 9.3697 1.46667 8 1.46667C6.6303 1.46667 5.37273 1.83028 4.22727 2.5575C3.08182 3.28472 2.20606 4.26556 1.6 5.5C2.20606 6.73444 3.08182 7.71528 4.22727 8.4425C5.37273 9.16972 6.6303 9.53333 8 9.53333Z"
      fill="#0A6FCD"
    />
  </svg>
)

export default SvgViewBlue
